// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1W2Bu","sendOtp":"AuthorizeToLogin_sendOtp__104HG"};